import { useBizQuery } from './useBizQuery';
import { getContainer, getAdminContainer, ContainerApiResponse } from '../Services/containerV2';
import { ContainerData, normalizeContainer, LegacyApiContainer } from '../Types/containerV2';

const QUERYKEY_CONTAINER_V2 = 'CONTAINER_V2';

/**
 * Resolves the ContainerData from the API response.
 * Currently the backend returns a legacy ContainerVersion wrapper.
 * When a V2 API is introduced, it can return ContainerData directly,
 * differentiated by a version property.
 */
function resolveContainerData(response: ContainerApiResponse): ContainerData {
	// Future: if the response has a version >= 2, use it directly
	// if (response.version && response.version >= 2) {
	//     return response as unknown as ContainerData;
	// }

	const legacy: LegacyApiContainer | undefined = response.Container ?? response.container;
	if (!legacy) {
		return { id: 0, placeholders: [], placeholderMode: 'variant' };
	}

	return normalizeContainer(legacy);
}

/**
 * Hook that fetches a container by ID and returns normalized ContainerData.
 * Normalization from the legacy format is handled transparently.
 */
export const useContainerV2 = (containerId?: number, admin = false) => {
	const fetchContainer = async () => {
		if (admin) return getAdminContainer(containerId!);
		const response = await getContainer(containerId!);
		return resolveContainerData(response);
	};

	const enabled = containerId !== undefined && containerId > 0;

	const { data, statusState, errorMessage } = useBizQuery<ContainerData, Error, readonly [string, number, boolean]>(
		[QUERYKEY_CONTAINER_V2, containerId!, admin],
		fetchContainer,
		enabled
	);

	return { container: data, statusState, errorMessage };
};
